// extracted by mini-css-extract-plugin
export default {"card-wrapper":"settings_card-wrapper__oUNFQ","reset-btn":"settings_reset-btn__I3omG","app-name":"settings_app-name__lXp1r"};